import React from 'react'
import { initializeApollo } from 'apps/next-unipolrental/client'
import { AllNewsDocument, PaginaDocument } from '@next-nx/shared-graphql/unipolrental'
import { NewsListingTemplate } from '@next-nx/shared-ui/templates'
import { NextWrapper } from '../../data-fetching-wrapper'

const NewsPage = ({ pagina, allNews }) => {
  return <NewsListingTemplate pagina={pagina} allNews={allNews} />
}

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PaginaDocument,
    variables: { chiave: 'news-listing' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  const { data } = await client.query({
    query: AllNewsDocument,
    variables: {
      orderBy: '-data_pubblicazione',
    },
  })

  return {
    props: { pagina, allNews: data }, // will be passed to the page component as props
    revalidate: 60, // In seconds
  }
})

export default NewsPage
